import { getCompanies } from '../../services';
import {
  fetchCompanies,
  setLoading,
  setLoaded,
  setSelectedCompany,
} from '../slices/companiesSlice';

export const getCompaniesThunk = () => {
  return async (dispatch) => {
    dispatch(setLoading());

    const companies = await getCompanies();

    dispatch(fetchCompanies(companies));
    dispatch(setLoaded());
  };
};

export const setSelectedCompanyThunk = (selectedCompanyInn) => {
  return (dispatch) => {
    dispatch(setSelectedCompany(selectedCompanyInn));
  };
};
